var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleMasterClosets = function SvgDoubleMasterClosets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    fillRule: "evenodd",
    d: "M39.878 8.468a.5.5 0 0 1 .5.5v30.064a.5.5 0 0 1-.5.5H8.122a.5.5 0 0 1-.5-.5V8.968a.5.5 0 0 1 .5-.5h31.756zm-24.316 1h-6.94v29.064h6.94V9.468zm7.938 0h-6.938v29.064H23.5V9.468zm7.94 0H24.5v29.064h6.94V9.468zm7.938 0H32.44v29.064h6.938V9.468zm-20.97 15.664a.5.5 0 0 1 0 1h-.949a.5.5 0 1 1 0-1h.948zm-3.793 0a.5.5 0 0 1 0 1h-.947a.5.5 0 1 1 0-1h.947zm19.67 0a.5.5 0 0 1 0 1h-.948a.5.5 0 1 1 0-1h.948zm-3.792 0a.5.5 0 0 1 0 1h-.947a.5.5 0 1 1 0-1h.947z"
  })));
};
export default SvgDoubleMasterClosets;